/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddNews = () => {
    const [formData, setFormData] = useState({
        title: '',
        type: 'news',
        publishedAt: new Date().toISOString().split('T')[0],
        content: '',
        file: null
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.title || !formData.type) {
            toast.error("Title and Type are required!");
            return;
        }

        setLoading(true);
        const data = new FormData();
        for (const key in formData) {
            if (formData[key] !== null && formData[key] !== '') {
                data.append(key, formData[key]);
            }
        }

        try {
            await postRequest('news', data);
            toast.success('Announcement added successfully!');
            navigate('/news');
        } catch (error) {
            console.error('Failed to add news:', error);
            toast.error(error?.message || 'Error occurred while creating news.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='container-fluid mt-5 mb-5'>
                <div className='mainheadig mx-4 mb-4'>
                    <h4 className='text-white font-weight-bold'>Add New Announcement</h4>
                </div>
                <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                    <div className='row'>
                        <div className='col-sm-8 form-group'>
                            <label className='admin-label font-weight-bold'>Title *</label>
                            <input
                                type='text'
                                name='title'
                                className='form-control'
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="e.g. Call for Startups: SAAKAR Program 2026"
                                required
                            />
                        </div>

                        <div className='col-sm-4 form-group'>
                            <label className='admin-label font-weight-bold'>Type *</label>
                            <select
                                name='type'
                                className='form-control'
                                value={formData.type}
                                onChange={handleChange}
                                required
                            >
                                <option value="news">News</option>
                                <option value="press release">Press Release</option>
                                <option value="circular">Circular</option>
                                <option value="notification">Notification</option>
                                <option value="recruitment">Recruitment</option>
                            </select>
                        </div>

                        <div className='col-sm-4 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Published Date</label>
                            <input
                                type='date'
                                name='publishedAt'
                                className='form-control'
                                value={formData.publishedAt}
                                onChange={handleChange}
                            />
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Announcement Content</label>
                            <textarea
                                name='content'
                                className='form-control'
                                rows="6"
                                value={formData.content}
                                onChange={handleChange}
                                placeholder="Write the main description or content here..."
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Circular Document (PDF / Image)</label>
                            <input
                                type='file'
                                name='file'
                                className='form-control filebg'
                                onChange={handleChange}
                                accept=".pdf,image/*"
                            />
                        </div>
                    </div>
                    
                    <div className='mt-4 text-right'>
                        <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={() => navigate('/news')}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className='btn addbtn pl-4 pr-4'
                            disabled={loading}
                        >
                            {loading ? 'Creating...' : 'Add Announcement'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddNews;
